module.exports = __webpack_public_path__ + "img/appIcon-ui--actionRefresh.00c4bf81.svg";